'use client'

import { CompanyIcon } from '@public/icons'

interface ICompanyHeader {
  header: string
}

const AuthHeader: React.FC<ICompanyHeader> = ({ header }) => {
  return (
    <>
      <div className="mb-[80px]">
        <CompanyIcon />
      </div>

      <h6 className="mb-5 text-[36px] font-extrabold text-black-neutral">
        {header}
      </h6>
    </>
  )
}

export default AuthHeader
